import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { ThemeMode } from 'config';
import { Box } from '@mui/material';

const LogoMain = ({ reverse }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === ThemeMode.DARK || reverse;
  const iconColor = isDark ? theme.palette.common.white : theme.palette.common.black;

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <svg width="40" height="40" viewBox="0 0 24 24" fill={iconColor} xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
      </svg>
    </Box>
  );
};

LogoMain.propTypes = {
  reverse: PropTypes.bool
};

export default LogoMain;
